import { useContext } from 'react';
import { BoardMemberContext } from '../context/boardMemberContext';

export function useBoardMembers() {
  const context = useContext(BoardMemberContext);

  if (!context) {
    throw new Error('useBoardMembers must be used inside BoardMemberProvider');
  }

  return context;
}
